import {
    IPatternBusinessLogic,
    IPatternProperties,
    Pattern,
} from '@vfde-brix/ws10/core';

type BrixComponent = Pattern<IPatternBusinessLogic, IPatternProperties<IPatternBusinessLogic>>;

/**
 * Returns the text before the passed element.
 * TODO: double check
 */
export const getTextBeforeFootnoteLink = ({ parentElement }: Element): string =>
    parentElement ? parentElement.innerText.slice(0, -1) : '';

/**
 * Returns elements in the Brix component with which the method was invoked
 * that have all the classes given by styleClass. The styleClass
 * argument is interpreted as a space-separated list of classes.
 */
export const getElementsByBrixClassName = (
    brix: BrixComponent | null,
    styleClass: string,
): Array<Element> => {
    const elements = brix?.getContainerElement().getElementsByClassName(styleClass);

    return elements ? Object.values(elements) : [];
};

/**
 * Returns an element in the Brix component with which the method was invoked
 * that have all the classes given by styleClass. The styleClass
 * argument is interpreted as a space-separated list of classes.
 */
export const getElementByBrixClassName = (
    brix: BrixComponent | null,
    styleClass: string,
): Element | undefined => {
    const [firstMatch] = getElementsByBrixClassName(brix, styleClass);

    return firstMatch;
};
